export default __webpack_public_path__ + "static/media/profile_pic2.80753c2a.jpg";